import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../Images/logo.svg";
import {
  Button,
  Dropdown,
  Navbar,
  Nav as BsNav,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import helpIcon from "../Images/aivideo1.gif";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoArrowRedoSharp } from "react-icons/io5";
const Nav = () => {
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [activeChildSubmenu, setActiveChildSubmenu] = useState(null);
  const submenuRef = useRef(null);
  const [expanded, setExpanded] = useState(false);

  const toggleSubmenu = (menu) => {
    setActiveSubmenu(activeSubmenu === menu ? null : menu);
    setActiveChildSubmenu(null);
  };

  const toggleChildSubmenu = (childMenu) => {
    setActiveChildSubmenu(activeChildSubmenu === childMenu ? null : childMenu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (submenuRef.current && !submenuRef.current.contains(event.target)) {
        setActiveSubmenu(null);
        setActiveChildSubmenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const submenuData = [
    {
      name: "Keyword Research",
      subMenu: ["Keyword Magic Tool", "Keyword Builder"],
    },
    {
      name: "Competitive Research",
      subMenu: [
        "Domain Overview",
        "Age Checker",
        "SERP Simulator",
        "Keyword Gap",
      ],
    },
    {
      name: "Link Building",
      subMenu: ["Linking Domain", "Top Pages", "Link Building Tool"],
    },
    {
      name: "Search Console",
      subMenu: ["URL Inspection", "Sitemap"],
    },
    {
      name: "Page Seo",
      subMenu: [
        "SEO Audit",
        "Pages",
        "Structure Data",
        "Internal Links",
        "Sitemap",
        "Social Links",
        "Robots.txt",
      ],
    },
    {
      name: "Google Trends",
      subMenu: ["Trending Now", "Interest Overtime", "Rising Topic"],
    },
  ];
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        // Change 50 to the threshold you prefer
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div
  className="d-flex justify-content-center"
  style={{
    background:
      "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
  }}
>
  <div
    className="d-flex flex-column flex-md-row align-items-center justify-content-center text-center text-md-start p-2 m-0"
    style={{
      fontFamily: "'Poppins', sans-serif",
      fontSize: ".9rem",
      fontWeight: "600",
      color: "#003366",
      letterSpacing: "0.5px",
      lineHeight: "1.6",
    }}
  >
    <img
      src={helpIcon}
      alt="Help"
      style={{ width: "2rem", height: "2rem", marginRight: "0.5rem", marginBottom: "0.5rem" }}
    />
    <span>
      Inspect Your Website’s SEO Performance in detail with the help of Free SeoBix’s Tools
      <a
        href="/Sitereport"
        className="text-decoration-none"
        style={{
          marginLeft: "0.5rem",
          color: "inherit",
        }}
      >
        <span style={{ color: "#FC4100" }}>
          Inspect Now <IoArrowRedoSharp />
        </span>
      </a>
    </span>
  </div>
</div>

      <div
        className={`sticky-navbar-wrapper ${isScrolled ? "shadow-sm" : ""}`}
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1050,
          background: "white",
        }}
      >
        <Row className="d-flex justify-content-center mx-md-0 mx-2">
          <Col md={10}>
            <Navbar
              expand="lg"
              bg="white"
              className="py-3 "
              expanded={expanded}
            >
              <Navbar.Brand as={Link} to="/" style={{ marginRight: "6rem" }}>
                <img src={logo} alt="Logo" style={{ height: "3rem" }} />
              </Navbar.Brand>

              <Navbar.Toggle
                aria-controls="responsive-navbar-nav"
                onClick={() => setExpanded(!expanded)}
              />

              <Navbar.Collapse id="responsive-navbar-nav">
                <BsNav className="me-auto d-flex align-items-lg-center gap-5">
                  <div className="dropdown-wrapper" ref={submenuRef}>
                    <span
                      className="nav-link-underline"
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleSubmenu("tools")}
                    >
                      Tools <MdKeyboardArrowDown />
                    </span>

                    {activeSubmenu === "tools" && (
                      <div className="submenu mt-2">
                        {submenuData.map((item) => (
                          <div key={item.name}>
                            <div
                              className="submenu-item"
                              onClick={() => toggleChildSubmenu(item.name)}
                            >
                              {item.name} ▾
                            </div>
                            {activeChildSubmenu === item.name && (
                              <div
                                className="submenu"
                                style={{ left: "100%", top: 0 }}
                              >
                                {item.subMenu.map((subItem, index) => (
                                  <div key={index}>
                                    {subItem === "Domain Overview" ? (
                                      <a
                                        href="/domain-overview-tool-examine-your-website-authority-in-just-one-click"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Keyword Gap" ? (
                                      <a
                                        href="/discover-your-competitors-keywords-to-boost-your-rankings-with-seobix"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "SEO Audit" ? (
                                      <a
                                        href="/run-a-free-seo-audit-and-uncover-hidden-ranking-issues"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Pages" ? (
                                      <a
                                        href="/one-click-to-every-page-and-your-ultimate-site-seo-is-ready"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Structure Data" ? (
                                      <a
                                        href="/transform-your-content-with-google-structured-data-for-better-search-results"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Internal Links" ? (
                                      <a
                                        href="/boost-your-seo-with-smart-internal-linking-strategies"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Sitemap" ? (
                                      <a
                                        href="/generate-your-perfect-sitemap-in-seconds-with-our-seobix-tool"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Social Links" ? (
                                      <a
                                        href="/boost-your-social-media-with-the-best-social-links-generator"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Robots.txt" ? (
                                      <a
                                        href="/help-google-crawlers-manage-website"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Age Checker" ? (
                                      <a
                                        href="/domain-age-checker-track-website-journey"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Link Building Tool" ? (
                                      <a
                                        href="/tracks-and-records-every-backlink-in-one-place"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "SERP Simulator" ? (
                                      <a
                                        href="/meta-description-preview-generator"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Linking Domain" ? (
                                      <a
                                        href="/seo-link-building-dashboard"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Trending Now" ? (
                                      <a
                                        href="/trending-now-on-google"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Interest Overtime" ? (
                                      <a
                                        href="/boost-google-ranking-with-keyword-interest"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Top Pages" ? (
                                      <a
                                        href="/track-the-top-performing-pages-of-website"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Rising Topic" ? (
                                      <a
                                        href="/increase-google-ranking-with-trending-topics"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "URL Inspection" ? (
                                      <a
                                        href="/best-url-inspection-tool"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Keyword Builder" ? (
                                      <a
                                        href="/construct-your-seo-success-with-keyword-builder"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : subItem === "Keyword Magic Tool" ? (
                                      <a
                                        href="/master-keyword-research-like-a-pro-with-our-keyword-magic-tool"
                                        className="submenu-item d-block text-decoration-none"
                                      >
                                        {subItem}
                                      </a>
                                    ) : (
                                      <div className="submenu-item">
                                        {subItem}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <Link className="nav-link-underline">Solutions</Link>
                  <Link className="nav-link-underline">Resources</Link>
                  <a href="/blog" className="nav-link-underline">
                    Blogs
                  </a>
                  {/* <Link
            to="/blog"
            className="nav-link-underline"
            onClick={() => sessionStorage.setItem("FromTag", "0")}
          >
            Blogs
          </Link> */}
                  <Link to="/pricing-plans" className="nav-link-underline">
                    Pricing
                  </Link>
                </BsNav>

                <div className="d-flex align-items-center gap-3 mt-3 mt-lg-0">
                  <span
                    style={{
                      color: "#333",
                      fontWeight: 500,
                      cursor: "pointer",
                      padding: "4px 12px",
                      border: "2px solid #007bff",
                      borderRadius: "6px",
                      fontSize: ".9rem",
                    }}
                    onClick={() =>
                      window.open("https://dashboard.seobix.com/", "_blank")
                    }
                  >
                    Login
                  </span>
                  <span
                    style={{
                      color: "#333",
                      fontWeight: 500,
                      cursor: "pointer",
                      padding: "4px 12px",
                      border: "2px solid #007bff",
                      borderRadius: "6px",
                      fontSize: ".9rem",
                    }}
                    onClick={() =>
                      window.open("https://dashboard.seobix.com/", "_blank")
                    }
                  >
                    Book a Demo
                  </span>

                  <Link to="/pricing-plans">
                    <span
                      style={{
                        color: "#fff",
                        fontWeight: 500,
                        cursor: "pointer",
                        padding: "7px 12px",
                        border: "1px solid #007bff",
                        backgroundColor: "#007bff",
                        borderRadius: "6px",
                        fontSize: ".9rem",
                      }}
                    >
                      Get Started Free
                    </span>
                  </Link>
                </div>
              </Navbar.Collapse>
            </Navbar>
          </Col>
        </Row>
      </div>{" "}
    </>
  );
};

export default Nav;
